var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE3DcBurger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e3dc_burger_svg__clip0_418_18812)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 21a4 4 0 014-4h45a4 4 0 010 8H15a4 4 0 01-4-4zm0 15.796a4 4 0 004 4h45a4 4 0 000-8H15a4 4 0 00-4 4zm0 15.796a4 4 0 004 4h45a4 4 0 000-8H15a4 4 0 00-4 4z",
    fill: "#4A4A4A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "e3dc_burger_svg__clip0_418_18812"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h74v74H0z"
  })))));
}
export default __webpack_public_path__ + "static/media/e3dc_burger.17d65e4e.svg";
export { SvgE3DcBurger as ReactComponent };